import { render } from "./app-test-mode-badge.vue?vue&type=template&id=12b8c246"
import script from "./app-test-mode-badge.vue?vue&type=script&lang=js"
export * from "./app-test-mode-badge.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/badge/app-test-mode-badge.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "12b8c246"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('12b8c246', __exports__)) {
    console.log('reload')
    api.reload('12b8c246', __exports__)
  }
  
  module.hot.accept("./app-test-mode-badge.vue?vue&type=template&id=12b8c246", () => {
    console.log('re-render')
    api.rerender('12b8c246', render)
  })

}


export default __exports__